import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postSalaryRowsInformation = async (
  salaryData,
  businessId,
  activeEmployerInfo
) => {
  const apiPath = `business/${businessId}/send-salary-information`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: salaryData,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
